import { render, staticRenderFns, recyclableRender, components } from "./details.vue?vue&type=template&id=39cbb4e8&scoped=true&"
var renderjs
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&lang=css&"
import style1 from "./details.vue?vue&type=style&index=1&id=39cbb4e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cbb4e8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/details/details.vue"
export default component.exports